import { useEffect, useState } from 'react';
import { Container, Card, Alert, Spinner } from 'react-bootstrap';
import { fetchUserAttributes, updateUserAttributes } from 'aws-amplify/auth';
import { useUserContext } from '../components/Context/UserContext'; // this is correct from /components/Debug

export default function AutoFixDisplayName() {
  const { refreshUser } = useUserContext();
  const [status, setStatus] = useState<'idle' | 'checking' | 'updating' | 'done' | 'skipped' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    (async () => {
      try {
        console.log('[FixName] mount');
        setStatus('checking');
        const attrs = await fetchUserAttributes();
        console.log('[FixName] Current attrs:', attrs);

        const email = (attrs.email as string) || '';
        const given = (attrs.given_name as string) || '';
        const name  = (attrs.name as string) || '';

        if (email.toLowerCase() !== 'denisetoo+33@gmail.com') {
          setStatus('skipped');
          setMessage(`Logged in as ${email}. This fixer only runs for denisetoo+33@gmail.com.`);
          return;
        }
        if (given === 'Maria' && name === 'Maria') {
          setStatus('skipped');
          setMessage('Name already set to Maria. Nothing to do.');
          return;
        }

        setStatus('updating');
        const resp = await updateUserAttributes({
          userAttributes: { given_name: 'Maria', name: 'Maria' },
        });
        console.log('[FixName] updateUserAttributes response:', resp);

        await refreshUser();
        const after = await fetchUserAttributes();
        console.log('[FixName] After refresh attrs:', after);

        const afterGiven = (after.given_name as string) || '';
        if (afterGiven !== 'Maria') {
          throw new Error(`Update did not stick. given_name is still "${afterGiven}".`);
        }

        setStatus('done');
        setMessage('✅ Updated given_name/name to Maria for denisetoo+33@gmail.com.');
      } catch (e: any) {
        console.error('[AutoFixDisplayName] Error:', e);
        setStatus('error');
        setMessage(e?.message || 'Failed to update name.');
      }
    })();
  }, [refreshUser]);

  return (
    <Container className="mt-4">
      <Card className="p-4">
        <h4>Auto Fix Display Name</h4>
        {status === 'checking' && (
          <div className="d-flex align-items-center gap-2 mt-3">
            <Spinner size="sm" /> <span>Checking current user…</span>
          </div>
        )}
        {status === 'updating' && (
          <div className="d-flex align-items-center gap-2 mt-3">
            <Spinner size="sm" /> <span>Updating name to Maria…</span>
          </div>
        )}
        {(status === 'done' || status === 'skipped' || status === 'error') && (
          <Alert
            className="mt-3"
            variant={status === 'error' ? 'danger' : status === 'done' ? 'success' : 'secondary'}
          >
            {message}
          </Alert>
        )}
        <p className="mt-3 mb-0">
          Visit this page while signed in as denisetoo+33@gmail.com. You can delete it after the fix.
        </p>
      </Card>
    </Container>
  );
}
